export const log = (message, e) => {
  console.log(message, e);
};
